module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00078-fs8.529f83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00078-fs8.png
// module id = 231
// module chunks = 0